<template>
  <div class="d-flex flex-column full-width">
    <div
      class="d-flex justify-content-between align-items-baseline mb-2 progress-details"
    >
      <div>
        <span v-if="file" class="file-name"
          ><b>{{ file.name }}</b></span
        >
      </div>
      <div class="d-flex">
        <div v-if="fileSize(file)">
          <span class="mr-1">{{ fileSize(file) }}</span>
          <span>·</span>
        </div>
        <span class="ml-1">{{ progress.toFixed() }}%</span>
      </div>
    </div>
    <div class="progress-bar-container">
      <div
        ref="progressBar"
        class="progress-bar"
        :class="{ complete: progress >= 100 }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    file: {
      type: File,
      default: null
    }
  },
  watch: {
    progress(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$refs.progressBar.style.width = `${newValue}%`;
      }
    }
  },
  mounted() {
    if (this.progress > 0) {
      this.$refs.progressBar.style.width = `${this.progress}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-bar-container {
  width: 100%;
  background: var(--light-gray);
  border-radius: 10px;
  height: 5px;
}
.progress-bar {
  background-color: var(--lightblue);
  width: 0%;
  transition: width 250ms ease, background-color 250ms ease;
  height: 100%;
  border-radius: 10px;
  &.complete {
    background-color: #28b34b;
  }
}
</style>
